import util from '@bmp-vue/core/api/util'

const controller = 'ArquivoGeradoDetalhe'
export default Object.assign({}, util.GetCrud(controller, ['getall']))
